import BaseFeature from '../../foundation/base/base';

const classes = {
	open: 'o-mobile-menu--open',
	activeItem: 'o-mobile-menu__link--active',
	mobileItemClass: '.o-mobile-menu__item',
	openMobileItem: 'o-mobile-menu__item--open'
};

export default class MobileMenu extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.body = window.features.dom.body;
		this.initDomCache();

		this.mobileExpanders = this.el.querySelectorAll('[data-js="item-expander"]');

		this.addEventListeners();
		this.addSubscriptions();
	}

	addEventListeners() {
		this.addEventListener(this.dom.link, 'click', (e) => {
			e.preventDefault();
			this.toggleMenu();
		});

		// Mobile items
		this.mobileExpanders.forEach((item) => {
			MobileMenu.hideMobileContent(item);

			this.addEventListener(item, 'click', (e) => {
				e.preventDefault();
				MobileMenu.toggleMobileItem(e.target);
			});
		});

		this.addEventListener(this.body, 'click', (e) => {
			if (!this.el.contains(e.target)) {
				this.el.classList.remove(classes.open);
			}
		});
	}

	addSubscriptions() {
		this.subscribe('/header/action/switch', () => {
			if (this.el.classList.contains(classes.open)) {
				this.el.classList.remove(classes.open);
			}
		});
	}

	/* ------------------------------------ *\
				General methods
	\* ------------------------------------ */

	toggleMenu() {
		if (this.el.classList.contains(classes.open)) {
			this.el.classList.remove(classes.open);
		} else {
			this.publish('/header/action/switch');
			this.el.classList.add(classes.open);
		}
	}


	closeMenu() {
		if (this.dom.secondSection.classList.contains(classes.openSection)) {
			this.dom.secondSection.classList.remove(classes.openSection);
		}
		if (this.el.classList.contains(classes.open)) {
			this.el.classList.remove(classes.open);
		}
		this.setActiveItem(null); // Remove active items when menu is closed
		this.clearSecondSection();
	}


	/* ------------------------------------ *\
				Desktop methods
	\* ------------------------------------ */

	/* ------------------------------------ *\
				Mobile methods
	\* ------------------------------------ */

	static hideMobileContent(item) {
		const section = item.closest(classes.mobileItemClass).querySelector('[data-js="item-section"]');
		section.style.maxHeight = '0px';
	}

	static toggleMobileItem(item) {
		// TODO: Update function to not use 'max-height none'.
		// Then we dont need to use a timeout, causing a slight delay in UX
		const target = item.closest(classes.mobileItemClass); // Get closest item
		const targetSection = target.querySelector('[data-js="item-section"]'); // Get section that should be expanded
		const targetHasSection = targetSection.querySelector('[data-js="item-section"]'); // Check if section has children sections

		if (target.classList.contains(classes.openMobileItem)) {
			// If item is open, remove class

			// Due to using 'max-height none' further down, before we can close item,
			// we need calculate the height and then set it to none.
			target.classList.remove(classes.openMobileItem);
			targetSection.style.maxHeight = targetSection.offsetHeight + 'px';
			// We need an empty timeout to be able to calculate height properly
			// due to 'co-operative multitasking'
			setTimeout(() => {
				targetSection.style.maxHeight = '0px';
			}, 0);
		} else {
			// Else, add 'open' class to item
			target.classList.add(classes.openMobileItem);
			// Update target section height
			if (targetSection) {
				targetSection.style.maxHeight = targetSection.scrollHeight + 'px';
			}
			// If target has no section, we need to update closest second section height
			if (!targetHasSection) {
				const topSection = target.closest('.o-mobile-menu__second-section');
				topSection.style.maxHeight = 'none';
			}
		}
	}
}
